(function(w, d, $, undefined) {
  'use strict';

  var $contactForms = null;


  w.reCaptchaCallback = function reCaptchaCallback(){
      $contactForms.submit()
  };


  w.contactPageInit = function contactPageInit(){
      d.addEventListener('DOMContentLoaded', function(){
          $contactForms = $('#contact-form');
      });
  };

}(this, this.document, this.jQuery));
